import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of, BehaviorSubject } from 'rxjs';
import { PremiumRange, DataPremiumSet } from '../models/insurePremium';
import { InsureProductCondition } from '../models/insureFactorCondition';
import { environment } from 'src/environments/environment';
import { map, catchError, retry } from 'rxjs/operators';

import { BaseComponents } from '../base.component';

@Injectable({
  providedIn: 'root'
})
export class BsInquiryInsurancePremiumRangeService extends BaseComponents{

  private $statePremiumRange: BehaviorSubject<StateResponsePremium> = new BehaviorSubject(null);
  premiumRangeData: Observable<StateResponsePremium> = this.$statePremiumRange.asObservable();

  constructor(
    protected injectorObj:Injector,
    private http: HttpClient, 
    //private logger: NGXLogger
  ) { 
    super(injectorObj);
  }


  getPremiumRange(data: InsureProductCondition): Observable<PremiumRange> {
    //return this.http.post()
    return this.http.post(`${environment.endpointBackend}/api/v1/rangeInsurePremium`, data).pipe(
      retry(1),
      catchError(this.handdleException),
      map(payload => {
        //console.log("payload: ", payload)
        let result: DataPremiumSet = payload["data"] as DataPremiumSet;
        return new PremiumRange(result.allowance, result.budget, result.roomFee)
      })
    )
  }


  loadPremiumRange(data: InsureProductCondition): void {
    //return this.http.post()
    if (!data) { return };

    this.http.post(`${environment.endpointBackend}/api/v1/rangeInsurePremium`, data).pipe(
      retry(1),
      catchError(this.handdleException),
      map(payload => {
        //console.log("payload: ", payload)
        if (payload['response_code'] === '40000') {
          let result: DataPremiumSet = payload["data"] as DataPremiumSet;
          return new PremiumRange(result.allowance, result.budget, result.roomFee)
        } else {
          return null;
        }

      })
    ).subscribe(
      data => data ? this.$statePremiumRange.next({ status: '200', data: data }) :
        this.$statePremiumRange.next({ status: '404', data: null }),

      err => this.$statePremiumRange.next({ status: '500', data: null }),

      //() => this.logger.info("complete get premium range")
    )
  }

  resetState(): void {
    this.$statePremiumRange.next(null);
  }


  handdleException(error: HttpErrorResponse): Observable<never> {
    this.logger.error(error)
    return throwError('error get data');
  }


}

interface StateResponsePremium {
  status: string,
  data: PremiumRange | null
}